import React from 'react';
import { colors } from '../assets/utils/colors';
import { Typography } from '@mui/material';

const CountBadge = ({ total, item }) => {
    return (
        <>
            <Typography
                sx={{
                    p: 1,
                    opacity: 0.8,
                    fontSize: 13,
                    borderRadius: 1,
                    fontWeight: 'bold',
                    background: `linear-gradient(180deg, ${colors.bgColor4}, ${colors.bgColor6})`,
                }}
            >
                {`${total} ${item}`}
            </Typography>
        </>
    );
};

export default CountBadge;
